/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  email: 'sandra@example.com',
  avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png'
}
